module.exports = __webpack_public_path__ + "img/travis.244caa9a.jpg";